<template>
  <v-app>
    <v-main>
      <router-view></router-view>
<!--      <TooltipMount/>-->
    </v-main>
  </v-app>
</template>

<script>
import { watch, ref } from '@vue/composition-api'
import { store } from '@/myops/core'
import TooltipMount from '@/components/TooltipMount'

export default {
  components: {
    // TooltipMount
  }
}
</script>

<style>
</style>
